import { atom } from "recoil";
export const clientAtom = atom({
  key: "clientAtom", // unique ID (with respect to other atoms/selectors)
  default: 0, // default value (aka initial value)
});
